import { render } from "./CourseInstructor.vue?vue&type=template&id=2e79c2b8"
import script from "./CourseInstructor.vue?vue&type=script&lang=js"
export * from "./CourseInstructor.vue?vue&type=script&lang=js"

import exportComponent from "/Users/gardener/OpenideProjects/Navigator_frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__